import { createRoot } from "react-dom/client";
import App from "Components/App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistedStore } from "Data/Redux/Store";
import { store } from "Data/Redux/Store";
import ErrorBoundary from "Components/ErrorBoundary";
import "./Styles/index.less";
import initFontAwesome from "src/FontAwesome";

const root = document.getElementById("app");

if (!root) {
	throw new Error("Root node is undefined.");
}

initFontAwesome();

const appComponent = (
	<ErrorBoundary>
		<Provider store={ store }>
			<PersistGate loading={ null } persistor={ persistedStore } >
				<App />
			</PersistGate>
		</Provider>
	</ErrorBoundary>
);

createRoot(root).render(appComponent);
